import { render, staticRenderFns } from "./calldetail.vue?vue&type=template&id=ce48fdfe&scoped=true&"
import script from "./calldetail.vue?vue&type=script&lang=js&"
export * from "./calldetail.vue?vue&type=script&lang=js&"
import style0 from "./calldetail.vue?vue&type=style&index=0&id=ce48fdfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce48fdfe",
  null
  
)

export default component.exports